export const Messages = {
  ERR_INVALID_TEMPLATE: 'Invalid tempalte. Please download latest format',
  ERR_INVALID_FILE_HEADERS: 'These column(s) are missing in your file: ',
  ERR_NO_RECORD_FOUND: 'No records Uploaded',
  ERR_NO_RECORDS_FOUND: 'No records were found ...',
  BULKUPLOAD_SUCCESS: "We're adding xls file data, which may take few minutes to upload",
  DATA_TYPE_ERROR: 'Fill out all the required fields',
  401: 'Unauthorized',
  403: "You don't have permission for this action",
  404: '404 Not Found',
  500: 'Un able to process your request',
  ADD_RECORD: 'Record Added Successfully',
  UPDATE_RECORD: 'Record Updated Successfully',

};

export { Messages as default };
